export function useAuth(...args) {
  // eslint-disable-next-line no-console
  console.warn('Placeholder: useAuth is not implemented yet.', args);
  return null;
}
